import React, { useState, useEffect } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import styled from "@emotion/styled"
import CommonTemplate from "templates/common-template"
import { Flex, Box } from "theme-ui"
import ResourceList from "components/lists/resources-list"
import SideNavBox from "components/lists/side-nav-box-list"
import SearchBar from "components/search-box"
import "react-tabs/style/react-tabs.css"

const ResourceWrapper = styled.div`
    position: relative;
    text-align: center;
    margin-bottom: 3rem;
    display: flex;
    flex-direction: row;
    z-index: 10;

    & .resources-wrapper {
        justify-content: space-between;
        flex-wrap: wrap;
    }
    & .tab-wrapper {
        flex: 0 0 70%;
    }
    & .side-box-wrapper {
        flex-direction: column;
        flex: 0 0 30%;
    }

    & .react-tabs__tab {
        color: ${(props) => props.theme.colors.secondary};
    }
    & .react-tabs__tab:focus {
        box-shadow: none;
    }
    & .react-tabs__tab-list {
        border: none;
    }
    & .react-tabs__tab--selected {
        background: transparent;
        border: none;
        border-bottom: 2px solid ${(props) => props.theme.colors.accent_blue};
        color: ${(props) => props.theme.colors.accent_blue};
    }
    & table.gsc-input tr td:first-of-type {
        width: 88%;
    }

    @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
        flex-direction: column;
        & .resources-wrapper {
            justify-content: center;
            padding: 0;
        }
        & table.gsc-input tr td:first-of-type {
            width: 93%;
        }
    }

    @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
        & table.gsc-input tr td:first-of-type {
            width: 90%;
        }
    }

    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        & table.gsc-input tr td:first-of-type {
            width: 87%;
        }
    }
`
const Title = styled.div`
    text-align: center;
    margin: 0.5rem 0;
    & p {
        color: ${(props) => props.theme.colors.text1};
        font-weight: 400;
    }
`

const JoinUs = styled.div`
    margin-top: 1rem;
    background: #ebf7ff;
    padding-bottom: 1rem;
    & > img {
        height: 200px;
        width: 100%;
    }
    & a {
        color: ${(props) => props.theme.colors.accent_blue};
    }
`


// markup
const IndexPage = ({ location }) => {
    const prefix = process.env.PREFIX_SLUG
    const data = useStaticQuery(query)

    const { posts } = data

    const recentPost = posts.edges.slice(0, 5)

    const [search, setSearch] = useState("")
    const [allData, setAllData] = useState(posts)

    const searchFilterData = (postData) => {
        return (
            postData.edges &&
            postData.edges.filter(
                (x) =>
                    x.node.title.toLowerCase().includes(search) ||
                    (x.node.Description &&
                        x.node.Description.toLowerCase().includes(search)) ||
                    (x.node.summary &&
                        x.node.summary.toLowerCase().includes(search))
            )
        )
    }
    useEffect(() => {
        if (search !== "") {
            const allFiltered = searchFilterData(posts)
            setAllData({ edges: allFiltered })
        } else {
            setAllData(posts)
        }
    }, [search])

    const customElements = (
        <>
            <ResourceWrapper>
                <Box className="tab-wrapper">
                    <Flex className="resources-wrapper">
                        <ResourceList data={{ posts: allData }} />
                    </Flex>
                </Box>
                <Flex className="side-box-wrapper">
                    <SearchBar searchData={setSearch} />
                    <SideNavBox
                        title="Recent Post (up to 5)"
                        data={recentPost}
                        prefix={prefix}
                        slug="resources/"
                    >
                        <JoinUs>
                            <img src="/join-with-us-today.jpg" alt="" />
                            <Title>
                                <p>Are you an awesome SpeechTherapist?</p>
                            </Title>
                            <Link to="/careers">Join with us Today!</Link>
                        </JoinUs>
                    </SideNavBox>
                </Flex>
            </ResourceWrapper>
        </>
    )

    const arrData = {
        location,
        data,
        customElement: customElements,
        breadcrums: ["Resources"],
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

const query = graphql`
    {
        pageData: strapiPage(
            slug: { eq: "wns-resources" }
            company: { shortname: { eq: "WNS" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            banner: image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED)
                }
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
            }
        }
        posts: allStrapiArticle(
            sort: { fields: published_date, order: DESC }
            filter: {
                category: { slug: { eq: "resources" } }
                Post_Type: { eq: "Blog_Post" }
            }
        ) {
            edges {
                node {
                    summary
                    Description
                    category {
                        name
                        slug
                    }
                    menu_title
                    slug
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                width: 400
                                height: 400
                            )
                        }
                    }
                    author {
                        name
                    }
                    tags {
                        name
                        slug
                    }
                    published_date
                }
            }
        }
    }
`
